import { useEffect, useState } from 'react';
import API from '../../api';

export default function EnseignantDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    API.get('stats/').then((r) => setStats(r.data)).catch(() => {});
  }, []);

  if (!stats) return <div className="loading-screen"><div className="spinner" /><p>Chargement…</p></div>;

  return (
    <div>
      <div className="page-header">
        <h2>Dashboard Enseignant</h2>
        <p>Vue d'ensemble de votre activité</p>
      </div>
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon blue"><i className="bi bi-book" /></div>
          <div className="stat-info"><h3>{stats.cours}</h3><p>Cours</p></div>
        </div>
        <div className="stat-card">
          <div className="stat-icon purple"><i className="bi bi-clipboard-check" /></div>
          <div className="stat-info"><h3>{stats.evaluations}</h3><p>Évaluations</p></div>
        </div>
        <div className="stat-card">
          <div className="stat-icon green"><i className="bi bi-people" /></div>
          <div className="stat-info"><h3>{stats.etudiants}</h3><p>Étudiants</p></div>
        </div>
      </div>
    </div>
  );
}
